import type { AppId, LauncherApp, LauncherAppId } from '../../types/appSuites'

/** Fixed Admin card. It is not one of the four configurable apps. */
export function adminShellApp(name: string, tagline: string, landingPath: string): LauncherApp {
  return {
    id: 'admin',
    enabled: true,
    name,
    tagline,
    icon: 'shield',
    accent_color: '#64748b',
    order: 100,
    landing_path: landingPath,
    sections: [{ id: 'admin', label: '', item_ids: ['admin', 'platform_admin'] }],
    extra_route_prefixes: [],
  }
}

export function isAdminPath(pathname: string): boolean {
  return (
    pathname === '/admin' ||
    pathname.startsWith('/admin/') ||
    pathname === '/platform-admin' ||
    pathname.startsWith('/platform-admin/')
  )
}

/** Admin owns its own routes. Every other URL keeps the product app that matched it. */
export function resolveShellAppId(
  pathname: string,
  adminAvailable: boolean,
  productId: AppId | null,
): LauncherAppId | null {
  if (adminAvailable && isAdminPath(pathname)) return 'admin'
  return productId
}
